import Headroom from 'headroom.js';

(function ($) {
	const siteHeader = document.querySelector('.site-header');
	const headroom = new Headroom(siteHeader);
	headroom.init();

	// Page Scroll Link
	const scrollPage = (targetID) => {
		if (!targetID) return;
		const position = targetID === '#' ? 0 : $(targetID).offset().top;
		$('html, body').animate(
			{
				scrollTop: position
			},
			600,
			'easeInOutQuart'
		);
	};

	$('a.in-page-scroll').on('click', function (e) {
		e.preventDefault();
		if ($(this).is('.menu-trigger')) return;
		const targetID = $(this).attr('href');
		scrollPage(targetID);
	});

	// Menu Trigger
	$(document).on('keyup', function (e) {
		if (e.code === 'Escape') {
			$('body').removeClass('show-menu');
			headroom.unfreeze();
		}
	});

	$(document).on('click', function () {
		$('body').removeClass('show-menu');
		headroom.unfreeze();
	});

	$('.menu-trigger').on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();

		$('body').toggleClass('show-menu');

		if ($('body').hasClass('show-menu')) {
			headroom.freeze();
		} else {
			headroom.unfreeze();
		}
	});

	// Show Reel Link
	$('.show-reel-item__link').fancybox({
		media: {
			youtube: {
				params: {
					autoplay: 1
				}
			}
		}
	});

	// Service Gallery Slider
	$('.service-gallery-menu a').on('click', function (e) {
		e.preventDefault();
		const parentItem = $(this).parent();
		const targetIndex = parentItem.index();
		const targetID = $(this).attr('href');
		const targetElm = $(targetID);

		parentItem.addClass('active');
		$('.service-gallery-menu li').not(parentItem).removeClass('active');

		targetElm.addClass('active');
		$('.service-gallery').not(targetElm).removeClass('active');

		if ($('body').hasClass('term-sound-studio')) {
			$('.tabs-wrapper').tabs('option', 'active', targetIndex);
		}
	});

	const gallerySlider = () => {
		const viewportWidth = $(window).innerWidth();

		if ($('.gallery-slider').hasClass('slick-initialized')) {
			$('.gallery-slider').slick('unslick');
		}

		if (viewportWidth > 740) {
			$('.gallery-slider').slick({
				arrows: false,
				dots: true,
				slidesToShow: 4,
				slidesToScroll: 4
			});
		} else {
			$('.gallery-slider').slick({
				arrows: false,
				dots: true,
				rows: 2,
				slidesPerRow: 2
			});
		}
	};

	$(window).on('load resize', function () {
		setTimeout(() => {
			gallerySlider();
		}, 60);
	});

	$('.tabs-wrapper').tabs({
		beforeActivate: function (event, ui) {
			const activeSlider = ui.newPanel.find('.show-reels-slider');
			setTimeout(function () {
				activeSlider.slick('setPosition');
			}, 60);
		}
	});

	$(window).on('load', function () {
		const currentMenuItem = document.querySelector('.current-service');
		if (currentMenuItem !== null) {
			currentMenuItem.scrollIntoView({
				inline: 'center'
			});
		}

		setTimeout(function () {
			$('.tabs-wrapper').tabs('refresh');
		}, 60);
	});

	// Show Reels Slider
	$('.show-reels-slider').slick({
		arrows: false,
		dots: true,
		rows: 2,
		slidesPerRow: 4,
		responsive: [
			{
				breakpoint: 740,
				settings: {
					arrows: false,
					dots: true,
					rows: 4,
					slidesPerRow: 2
				}
			}
		]
	});

	// Ze-Flick
	$('.ze-flick-selector').on('change', function () {
		const selectedValue = $(this).val();
		$(selectedValue).addClass('active');
		$('.ze-flick-section').not($(selectedValue)).removeClass('active');
	});
})(jQuery);
